import { API_URL as API, BACKEND_URL } from '../utils/config';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';


const Shop = () => {
  const { t } = useLanguage();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      console.log('Fetching products from:', `${API}/products?category=foundation`);
      const response = await axios.get(`${API}/products?category=foundation`);
      console.log('Products received:', response.data);
      setProducts(response.data || []);
    } catch (error) {
      console.error('Failed to fetch products:', error);
      console.error('Error details:', error.response?.data);
      // Fallback to hardcoded products if API fails
      setProducts([
        {
          id: "33707ad3-d38e-4edd-b17b-6f522d1eb475",
          name_en: "Moist Foundation #04 Glow Light",
          name_no: "Moist Foundation #04 Glow Light",
          image_url: "https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/x3m2ldde_Screenshot%202025-12-10%20at%2001.02.38.png",
          price_nok: 649,
          shades: [{ shade: "04", name: "Glow Light" }],
          category: "foundation"
        },
        {
          id: "723c6817-4a4f-490c-a156-57e7e9e3848c",
          name_en: "Silk Foundation #04 Basic Warm",
          name_no: "Silk Foundation #04 Basic Warm",
          image_url: "https://customer-assets.emergentagent.com/job_cosmobeauty-shop/artifacts/90lceq6f_Screenshot%202025-12-10%20at%2001.00.26.png",
          price_nok: 549,
          shades: [{ shade: "04", name: "Basic Warm" }],
          category: "foundation"
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const getShadeText = (product) => {
    if (product.shades && product.shades.length > 0) {
      return product.shades[0].name;
    }
    return '';
  };

  const getCategoryText = (product) => {
    if (product.category === 'foundation') {
      return t.language === 'no' ? 'Foundation' : 'Foundation';
    }
    return product.category;
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7] pt-32 pb-24" data-testid="shop-page">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <h1 className="text-xs font-sans font-bold tracking-tight leading-none text-[#1A1A1A] mb-12 text-center uppercase">
          FOUNDATION
        </h1>

        {/* Products Grid */}
        {loading ? (
          <div className="text-center py-12" data-testid="loading-indicator">
            <p className="text-[#8A8A8A]">{t('loading') || 'Loading...'}</p>
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-12" data-testid="no-products">
            <p className="text-[#8A8A8A]">{t('noProducts') || 'No products found'}</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-2xl mx-auto" data-testid="products-grid">
            {products.map(product => {
              const name = t.language === 'no' ? product.name_no : product.name_en;
              return (
                <div key={product.id} className="text-center" data-testid={`product-${product.id}`}>
                  <div className="bg-white p-3 mb-2 shadow-md rounded-lg flex items-center justify-center" style={{ height: '120px' }}>
                    <img 
                      src={product.image_url} 
                      alt={name} 
                      className="h-24 w-auto object-contain"
                    />
                  </div>
                  <h3 className="text-lg font-sans text-[#1A1A1A] mb-1">
                    {name}
                  </h3>
                  <p className="text-sm text-[#8A8A8A] mb-1">{getShadeText(product)}</p>
                  <p className="text-xs uppercase tracking-[0.2em] text-[#8A8A8A] mb-2">
                    {getCategoryText(product)}
                  </p>
                  <p className="text-base font-sans text-[#1A1A1A] mb-3">{product.price_nok} NOK</p>
                  <Link 
                    to={`/product/${product.id}`}
                    className="inline-block bg-[#1A1A1A] text-white px-5 py-2 text-xs uppercase tracking-[0.2em] hover:bg-[#333333] transition-all duration-300"
                  >
                    {t('shopNow')}
                  </Link>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Shop;